/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconShapeCircleTick = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.909 5.57l-4.114 5.926c-.31.456-.623.456-1.095-.013L4.133 8.745c-.188-.203-.175-.582.028-.77s.518-.207.707-.004l2.355 2.531 3.869-5.503a.498.498 0 1 1 .818.57z"
    />
  </svg>
);

IconShapeCircleTick.displayName = 'IconShapeCircleTick';

IconShapeCircleTick.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconShapeCircleTick);
IconShapeCircleTick.displayName = 'IconShapeCircleTick';
